import {assortments, getUserObject} from "utils/relewise";

function getPopularProductsPersonal(options) {
  return {
    sinceMinutesAgo: options.minutesAgo, // TODO: convert daysAgo to Minutes
    Settings: {
      NumberOfRecommendations: 10,
      AllowFillIfNecessaryToReachNumberOfRecommendations: true,
      AllowReplacingOfRecentlyShownRecommendations: true,
      RecommendVariant: true,
      SelectedProductProperties: {
        DisplayName: true,
        Pricing: true,
      },
    },
    Language: {
      Value: window.mosmosh.shop_local.iso,
    },
    User: getUserObject(),
    Currency: {
      Value: window.mosmosh.currency.iso,
    },
    Filters: {
      Items: [
        {
          $type:
              "Relewise.Client.Requests.Filters.ProductDataFilter, Relewise.Client",
          Key: "Vendor",
          FilterOutIfKeyIsNotFound: true,
          MustMatchAllConditions: true,
          Conditions: {
            Items: [
              {
                $type:
                    "Relewise.Client.Requests.Conditions.EqualsCondition, Relewise.Client",
                Value: {
                  Value: options.vendor,
                },
                TypeName: "EqualsCondition",
              },
            ],
          },
          TypeName: "ProductDataFilter",
        },
        {
          $type:
              "Relewise.Client.Requests.Filters.ProductAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "ProductAssortmentFilter",
        },
        {
          $type:
              "Relewise.Client.Requests.Filters.VariantAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "VariantAssortmentFilter",
        },
      ],
    },
  };
}

export default getPopularProductsPersonal
